export interface INotification {
  id: string;
  message: string;
  timeout: number;
  type: ENotificationType;
}

export type TNotificationsState = INotification[];

export enum ENotificationType {
  Error = 'error',
}
